<script>
  import Rating from "../components/Rating.svelte";

  import { fade } from "svelte/transition";
  import Img from "../components/Img.svelte";
  import Load from "../components/Load.svelte";
  import "../../node_modules/croppie/croppie.css";
  import format from "number-format.js";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Modal from "../components/Modal.svelte";
  //liblary
  import axios from "axios";

  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  export let data;
  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }
  //alert
  let alert = [];
  let itemsOrderDisplay = false;
  let loadOrder = "block";
  let itemsOrder = [];
  let itemsOrderNotif = [];

  if (data) {
    loadTransaction(data.status);
  } else {
    loadTransaction("all");
  }

  function loadTransaction(status = "all") {
    axios
      .get(settings.url + "/sipade/pembelian/" + status, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        itemsOrderNotif = response.data.count;
        itemsOrder = response.data.data;
        itemsOrderDisplay = true;
        loadOrder = "hidden";
        setTimeout(() => {
          btnfilterActivate(status);
        }, 500);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }

  function statusUpdate(id, status) {
    axios
      .post(
        settings.url + "/sipade/orderstatus?authorization=" + settings.token,
        {
          transactionID: id,
          status: status,
        }
      )
      .then(function (response) {
        loadTransaction("all");
      })
      .catch(function (error) {
        window.location.reload();
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        }
      });
  }

  function btnfilterActivate(id) {
    Array.from(document.getElementsByClassName("btnfilter")).forEach((el) => {
      el.classList.remove("font-bold");
    });
    if (id) {
      document.getElementById("btnfilter-" + id).classList.add("font-bold");
    } else {
      this.classList.add("font-bold");
    }
  }
</script>

<svelte:head>
  <title>Transaksi - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 mb-10 right-0 z-30 px-2 mx-auto lg:w-auto w-full">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<Navigationbar
  backbtn="true"
  message={navigation["message"]}
  title="Transaksi Anda"
/>

<main
  transition:fade
  class="container lg:pt-24 md:pt-20 pt-24 mx-auto mb-32 lg:px-0 px-1"
>
  <div class="flex">
    <div class="w-full mx-auto lg:my-5 px-2">
      {#if itemsOrderDisplay}
        <div class="w-full bg-white rounded-lg shadow p-2 mt-5 overflow-x-auto">
          <div class="flex justify-between text-xs">
            <span
              class="text-gray-800 text-lg font-bold px-4 my-2 flex  items-center justify-center"
              >Status</span
            >
            <a
              on:click={() => loadTransaction("all")}
              id="btnfilter-all"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300 font-bold"
              href="/akun/transaksi/all"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Semua Pesanan
              </div>
            </a>
            <a
              on:click={() => loadTransaction("0")}
              id="btnfilter-0"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300"
              href="/akun/transaksi/0"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Pesanan Baru
                {#if itemsOrderNotif.status_0_res.counter > 0}
                  <span
                    class="absolute top-0 right-0 -mt-3 -mr-3 bg-red-500 px-2 rounded-full text-white"
                    >{itemsOrderNotif.status_0_res.counter}</span
                  >
                {/if}
              </div>
            </a>
            <a
              on:click={() => loadTransaction("100")}
              id="btnfilter-100"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300"
              href="/akun/transaksi/100"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Pesanan Diproses
                {#if itemsOrderNotif.status_100_res.counter > 0}
                  <span
                    class="absolute top-0 right-0 -mt-3 -mr-3 bg-red-500 px-2 rounded-full text-white"
                    >{itemsOrderNotif.status_100_res.counter}</span
                  >
                {/if}
              </div>
            </a>
            <a
              on:click={() => loadTransaction("200")}
              id="btnfilter-200"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300"
              href="/akun/transaksi/200"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Proses Pengiriman
                {#if itemsOrderNotif.status_200_res.counter > 0}
                  <span
                    class="absolute top-0 right-0 -mt-3 -mr-3 bg-red-500 px-2 rounded-full text-white"
                    >{itemsOrderNotif.status_200_res.counter}</span
                  >
                {/if}
              </div>
            </a>
            <a
              on:click={() => loadTransaction("300")}
              id="btnfilter-300"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300"
              href="/akun/transaksi/300"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Dalam Pengiriman
                {#if itemsOrderNotif.status_300_res.counter > 0}
                  <span
                    class="absolute top-0 right-0 -mt-3 -mr-3 bg-red-500 px-2 rounded-full text-white"
                    >{itemsOrderNotif.status_300_res.counter}</span
                  >
                {/if}
              </div>
            </a>
            <a
              on:click={() => loadTransaction("400")}
              id="btnfilter-400"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300"
              href="/akun/transaksi/400"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Pesanan Selesai
                {#if itemsOrderNotif.status_400_res.counter > 0}
                  <span
                    class="absolute top-0 right-0 -mt-3 -mr-3 bg-red-500 px-2 rounded-full text-white"
                    >{itemsOrderNotif.status_400_res.counter}</span
                  >
                {/if}
              </div>
            </a>
            <a
              on:click={() => loadTransaction("500")}
              id="btnfilter-500"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300"
              href="/akun/transaksi/500"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Pesanan Dibatalkan
                {#if itemsOrderNotif.status_500_res.counter > 0}
                  <span
                    class="absolute top-0 right-0 -mt-3 -mr-3 bg-red-500 px-2 rounded-full text-white"
                    >{itemsOrderNotif.status_500_res.counter}</span
                  >
                {/if}
              </div>
            </a>
            <a
              on:click={() => loadTransaction("600")}
              id="btnfilter-600"
              class="lg:w-auto text-gray-800 btnfilter  md:w-1/4 w-1/2 px-4 py-2 my-1 mx-1 bg-white
            shadow-md rounded-full cursor-pointer hover:text-green-700
            border hover:border-green-300"
              href="/akun/transaksi/600"
              ><div
                class="flex justify-between items-center text-center relative"
              >
                Pesanan Dikembalikan
                {#if itemsOrderNotif.status_600_res.counter > 0}
                  <span
                    class="absolute top-0 right-0 -mt-3 -mr-3 bg-red-500 px-2 rounded-full text-white"
                    >{itemsOrderNotif.status_600_res.counter}</span
                  >
                {/if}
              </div>
            </a>
          </div>
        </div>
        <div class="w-full mt-5">
          {#if itemsOrder.length > 0}
            {#each itemsOrder as it}
              <section
                class="w-full text-sm rounded-lg shadow-lg px-5 py-2 bg-white my-5"
              >
                <div class="flex justify-between border-b py-2">
                  <div class="text-gray-600 font-light text-xs">
                    {it.date}
                    WIB
                  </div>
                  <div class="">
                    <div
                      class="rounded-lg bg-green-200 px-2 text-gray-600 font-light text-xs"
                    >
                      {it.pay_method}
                    </div>
                  </div>
                </div>
                <div
                  class=" flex items-center justify-between flex-wrap mx-auto lg:my-0  py-2"
                >
                  <div class="lg:w-4/12  overflow-hidden">
                    <a
                      href="/belanja/{it.details.shop.domain}"
                      class="font-bold block text-blue-500"
                      >{it.details.shop.nameShop}</a
                    ><span
                      class="text-gray-600 font-light truncate whitespace-pre-wrap leading-6"
                      >({it.inv})</span
                    >
                  </div>
                  <div class="lg:w-2/12 border-l px-2">
                    <div class="text-xs">Status</div>
                    <div class="font-bold">
                      {#if it.status == 0}Pesanan Disampaikan{/if}
                      {#if it.status == 100}Pesanan Diproses{/if}
                      {#if it.status == 200}Proses Pengiriman{/if}
                      {#if it.status == 300}Pengiriman Disiapkan{/if}
                      {#if it.status == 301}Penjemputan Paket{/if}
                      {#if it.status == 302}Pengiriman Paket Terkonfirmasi{/if}
                      {#if it.status == 303}Paket Dalam Perjalanan{/if}
                      {#if it.status == 304}Resi Tidak Valid{/if}
                      {#if it.status == 305}Resi Diubah{/if}
                      {#if it.status == 306}Menunggu Pengambilan{/if}
                      {#if it.status == 307}Dikembalikan{/if}
                      {#if it.status == 308}Pesanan Tiba{/if}
                      {#if it.status == 309}Pesanan Dikomplain{/if}
                      {#if it.status == 400}Pesanan Selesai{/if}
                      {#if it.status == 500}Pesanan Dibatalkan{/if}
                      {#if it.status == 600}Pesanan Dikembalikan{/if}
                    </div>
                  </div>
                  <div class="lg:w-2/12">
                    <div class="px-2">
                      <span class="text-xs">Total Belanja</span>
                      <div class="font-bold text-green-600">
                        {format("Rp #.###,", it.total)}
                      </div>
                    </div>
                  </div>
                  <div class="lg:w-2/12">
                    <div class="px-2">
                      <div class="font-bold text-green-600">
                        {#if it.status == 0}<span
                            class="text-orange-600 text-xs"
                            >Menunggu Konfirmasi Penjual</span
                          >{/if}
                        {#if it.status == 100}<span
                            class="text-orange-600 text-xs"
                            >Pesanan Sedang Diproses Penjual</span
                          >{/if}
                        {#if it.status == 200}<span
                            class="text-orange-600 text-xs"
                            >Penjual Menyiapkan Pengiriman</span
                          >{/if}
                        {#if it.status == 300}<span
                            class="text-orange-600 text-xs"
                            >Menunggu Proses Pengiriman</span
                          >{/if}
                        {#if it.status == 301}<span
                            class="text-orange-600 text-xs"
                            >Pesanan diproses oleh kurir</span
                          >{/if}
                        {#if it.status == 302}
                          <span class="text-orange-600 text-xs"
                            >Paket Sudah Dalam Penanganan Kurir</span
                          >
                        {/if}
                        {#if it.status == 303}<span
                            class="text-orange-600 text-xs"
                            >Kurir Menuju Lokasi Anda</span
                          >{/if}
                        {#if it.status == 304}<span class="text-red-600 text-xs"
                            >Resi Tidak Valid</span
                          >{/if}
                        {#if it.status == 305}<span
                            class="text-orange-600 text-xs">Resi Diubah</span
                          >{/if}
                        {#if it.status == 306}<span
                            class="text-orange-600 text-xs"
                            >Menunggu Pengambilan</span
                          >{/if}
                        {#if it.status == 307}<span
                            class="text-orange-800 text-xs">Dikembalikan</span
                          >{/if}
                        {#if it.status == 308}
                          <Modal backdropClose size="lg:w-2/5 w-full">
                            <div slot="trigger" let:open>
                              <button
                                on:click={open}
                                class="w-full px-4 py-2 my-1 mx-1 bg-blue-500
                              shadow-md rounded-full cursor-pointer text-gray-200 hover:shadow focus:bg-gray-500 focus:outline-none"
                                ><span>Paket Diterima</span></button
                              >
                            </div>
                            <div slot="header" class="text-center">
                              <h1 class="text-lg">Selesaikan Transaksi Ini</h1>
                              Berikan Penilaian kepada Kurir & Penjual
                            </div>
                            <div
                              slot="content"
                              class="h-auto"
                              style="max-height:100%"
                            >
                              <div
                                class="h-full w-full lg:flex lg:justify-between mb-5"
                              >
                                <div
                                  class="w-full text-center my-4 lg:border-r-2 border-b-2 lg:border-b-0 pb-5 lg:pb-auto"
                                >
                                  <h2 class="font-normal mb-2 w-full">
                                    Berikan penilaian kepada<br /><b
                                      >{it.shipper.nama_pen}</b
                                    ><br />(Kurir)
                                  </h2>
                                  <div class="flex justify-center">
                                    {#if it.rating_ship != 0}
                                      <Rating
                                        size="8"
                                        rating={it.rating_ship}
                                      />
                                    {:else}
                                      <Rating
                                        size="8"
                                        action="sipade/ratings/shipper"
                                        id={it.ID}
                                      />
                                    {/if}
                                  </div>
                                </div>
                                <div class="w-full text-center my-4">
                                  <h2 class="font-normal mb-2 w-full">
                                    Berikan penilaian kepada<br /><b
                                      >{it.details.shop.nameShop}</b
                                    ><br />(Penjual)
                                  </h2>
                                  <div class="flex justify-center">
                                    {#if it.rating != 0}
                                      <Rating size="8" rating={it.rating} />
                                    {:else}
                                      <Rating
                                        size="8"
                                        action="sipade/ratings/shop"
                                        id={it.ID}
                                      />
                                    {/if}
                                  </div>
                                </div>
                              </div>
                              <button
                                on:click|preventDefault={() =>
                                  statusUpdate(it.ID, 400)}
                                class="w-full px-4 py-2 my-1 bg-blue-500
                          shadow-md rounded-full cursor-pointer text-gray-200 hover:shadow focus:bg-gray-500 focus:outline-none"
                                ><span>Paket Diterima</span></button
                              >
                            </div>
                          </Modal>
                        {/if}
                        {#if it.status == 309}Pesanan Dikomplain{/if}
                        {#if it.status == 400}<span
                            class="text-orange-600 text-xs"
                            >Transaksi selesai</span
                          >{/if}
                        {#if it.status == 500}<span
                            class="text-orange-600 text-xs"
                            >Transaksi Dibatalkan</span
                          >{/if}
                        {#if it.status == 600}Pesanan Dikembalikan{/if}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="body  border-t py-2">
                  {#each it.details.products as p}
                    <div class="w-full border-b py-2">
                      <div>
                        <div class="w-full flex justify-between">
                          <div class="w-16">
                            <Img
                              csscont="none"
                              showplaceholder="false"
                              id={p.details.name}
                              datasrc="https://pics.dekatan.com/{p.pictures
                                .fileName}"
                              css="rounded-lg shadow"
                              alt="img-product"
                            />
                          </div>
                          <div class="w-full px-2">
                            <div class="font-bold text-blue-500">
                              <div>{p.details.name}</div>
                            </div>
                            <div class="font-light">
                              <span class="w-full pr-2 text-green-600">
                                {format("Rp #.###,", p.details.price)}</span
                              ><span class="w-full text-gray-600"
                                >{p.quantity}
                                Produk</span
                              >
                            </div>
                          </div>
                          <div class="border-l px-2 w-2/5">
                            <div class="text-xs ellipsis-2">
                              Total Harga Produk
                            </div>
                            <div
                              class="lg:font-bold font-normal text-green-600"
                            >
                              {format("Rp #.###,", p.subtotal)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  {/each}
                  <div class="w-full border-b py-2 flex justify-between">
                    <Modal backdropClose size="lg:w-1/2 w-full">
                      <div slot="trigger" let:open>
                        <span
                          class="lg:w-auto md:w-1/4 w-full px-4 py-2 my-1 mx-1 bg-teal-600
                          shadow-md rounded-full cursor-pointer text-gray-200 hover:shadow"
                          on:click={open}>Lihat Proses</span
                        >
                      </div>
                      <div slot="header">
                        <h1 class="text-lg">Detail Proses Transaksi Anda</h1>
                      </div>
                      <div slot="content">
                        <div class="relative">
                          <div class="w-full flex my-5">
                            <div class="lg:w-6/12  overflow-hidden">
                              <a
                                href="/belanja/{it.details.shop.domain}"
                                class="font-bold block text-blue-500"
                                >{it.details.shop.nameShop}</a
                              ><span
                                class="text-gray-600 font-light truncate whitespace-pre-wrap leading-6"
                                >({it.inv})</span
                              >
                            </div>
                            <div class="lg:w-2/12 border-l px-2">
                              <div class="text-xs">Status</div>
                              <div class="font-bold">
                                {#if it.status == 0}Pesanan Disampaikan{/if}
                                {#if it.status == 100}Pesanan Diproses{/if}
                                {#if it.status == 200}Proses Pengiriman{/if}
                                {#if it.status == 300}Pengiriman Disiapkan{/if}
                                {#if it.status == 301}Penjemputan Paket{/if}
                                {#if it.status == 302}
                                  Pengiriman Paket Terkonfirmasi
                                {/if}
                                {#if it.status == 303}
                                  Paket Dalam Perjalanan
                                {/if}
                                {#if it.status == 304}Resi Tidak Valid{/if}
                                {#if it.status == 305}Resi Diubah{/if}
                                {#if it.status == 306}Menunggu Pengambilan{/if}
                                {#if it.status == 307}Dikembalikan{/if}
                                {#if it.status == 308}Pesanan Tiba{/if}
                                {#if it.status == 309}Pesanan Dikomplain{/if}
                                {#if it.status == 400}Pesanan Selesai{/if}
                                {#if it.status == 500}Pesanan Dibatalkan{/if}
                                {#if it.status == 600}Pesanan Dikembalikan{/if}
                              </div>
                            </div>
                          </div>
                          <div class="w-full my-5">
                            <h2 class="text-gray-900 font-bold text-xs my-4">
                              Daftar Produk
                            </h2>
                            {#each it.details.products as p}
                              <div class="w-full border-b py-2">
                                <div>
                                  <div class="w-full flex justify-between">
                                    <div class="w-16">
                                      <Img
                                        csscont="none"
                                        showplaceholder="false"
                                        id={p.details.name}
                                        datasrc="https://pics.dekatan.com/{p
                                          .pictures.fileName}"
                                        css="rounded-lg shadow"
                                        alt="img-product"
                                      />
                                    </div>
                                    <div class="w-full px-2">
                                      <div class="font-bold text-blue-500">
                                        <div>{p.details.name}</div>
                                      </div>
                                      <div class="font-light">
                                        <span
                                          class="w-full pr-2 text-green-600"
                                        >
                                          {format(
                                            "Rp #.###,",
                                            p.details.price
                                          )}</span
                                        ><span class="w-full text-gray-600"
                                          >{p.quantity}
                                          Produk</span
                                        >
                                      </div>
                                    </div>
                                    <div class="border-l px-2 w-2/5">
                                      <div class="text-xs ellipsis-2">
                                        Total Harga Produk
                                      </div>
                                      <div
                                        class="lg:font-bold font-normal text-green-600"
                                      >
                                        {format("Rp #.###,", p.subtotal)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            {/each}
                          </div>
                          <div class="w-full my-5">
                            <h2 class="text-gray-900 font-bold text-xs my-4">
                              Pengiriman
                            </h2>
                            {#if it.shipper}
                              <p class="text-xs font-light mb-4">
                                Yang Ngirim<br />
                                <span class="font-bold"
                                  >{it.shipper.nama_pen}</span
                                ><br />
                                {it.shipper.no_pen}<br />
                                Telp.{it.shipper.hp}<br />
                              </p>
                            {/if}
                            <p class="text-xs font-light">
                              Dikirim Kepada<br />
                              <span class="font-bold"
                                >{it.details.ship.nama_penerima}</span
                              ><br />
                              {it.details.ship.address}<br />
                              {it.details.ship.address_map}<br />
                              {it.details.ship.telp}<br />
                              <span class="italic"
                                >{it.details.ship.catatan}</span
                              ><br />
                            </p>
                          </div>

                          <div class="w-full my-5">
                            <h2 class="text-gray-900 font-bold text-xs my-4">
                              Pembayaran
                            </h2>
                            <div
                              class="flex justify-between text-xs font-light w-8/12"
                            >
                              <div class="p-2 text-gray-500">
                                Metode Pembayaran<br />
                                Total Harga ({it.details.summary.items}
                                Item)<br />
                                Total Ongkos Kirim<br />
                                Total Bayar
                              </div>
                              <div
                                class="p-2 text-gray-700 border-l font-normal"
                              >
                                {it.pay_method}<br />
                                {format("Rp #.###,", it.pricing)}<br />
                                {format("Rp #.###,", it.shipment)}<br />
                                {format("Rp #.###,", it.total)}
                              </div>
                            </div>
                          </div>

                          <div class="w-full my-5">
                            <h2 class="text-gray-900 font-bold text-xs my-4">
                              Status Transaksi
                            </h2>
                            <ul>
                              {#each it.history.reverse() as h, i}
                                {#if i == 0}
                                  <li
                                    class="w-full flex mt-1 border-b text-gray-800 font-normal"
                                  >
                                    <div
                                      class="p-2 border-r text-right lg:w-4/12"
                                    >
                                      {#if h.by == "20"}
                                        <span
                                          class="w-full bg-teal-300 rounded-full px-2"
                                          >Penjual</span
                                        >
                                      {/if}
                                      {#if h.by == "30"}
                                        <span
                                          class="w-full bg-blue-300 rounded-full px-2"
                                          >Kurir</span
                                        >
                                      {/if}
                                      {#if h.by == "10"}
                                        <span
                                          class="w-full bg-orange-300 rounded-full px-2"
                                          >Anda</span
                                        >
                                      {/if}
                                      <br />
                                      <span class="font-thin text-xs"
                                        >{h.date}
                                        WIB</span
                                      >
                                    </div>
                                    <div class="p-2 items-center flex w-full">
                                      {h.status_text}
                                    </div>
                                  </li>
                                {:else}
                                  <li
                                    class="w-full flex mt-1 border-b text-gray-600 font-light"
                                  >
                                    <div
                                      class="p-2 border-r text-right lg:w-4/12"
                                    >
                                      {#if h.by == "20"}
                                        <span
                                          class="w-full bg-teal-300 rounded-full px-2"
                                          >Penjual</span
                                        >
                                      {/if}
                                      {#if h.by == "30"}
                                        <span
                                          class="w-full bg-blue-300 rounded-full px-2"
                                          >Kurir</span
                                        >
                                      {/if}
                                      {#if h.by == "10"}
                                        <span
                                          class="w-full bg-orange-300 rounded-full px-2"
                                          >Anda</span
                                        >
                                      {/if}
                                      <br />
                                      <span class="font-thin text-xs"
                                        >{h.date}
                                        WIB</span
                                      >
                                    </div>
                                    <div class="p-2 items-center flex w-full">
                                      {h.status_text}
                                    </div>
                                  </li>
                                {/if}
                              {/each}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </Modal>
                    {#if it.rating != 0}
                      <Rating size="4" rating={it.rating} />
                    {/if}
                  </div>
                </div>
              </section>
            {/each}
          {:else}
            <p
              class="text-center rounded bg-white shadow-md p-5 font-light text-gray-500 w-full"
            >
              Belum ada transaksi dengan status terpilih
            </p>
          {/if}
        </div>
      {:else}<Load />{/if}
    </div>
  </div>
</main>
